import { render, staticRenderFns } from "./MakePayment.vue?vue&type=template&id=52c0f2be"
import script from "./MakePayment.vue?vue&type=script&lang=js"
export * from "./MakePayment.vue?vue&type=script&lang=js"
import style0 from "./MakePayment.vue?vue&type=style&index=0&id=52c0f2be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports